/* eslint-disable */
import React, { useState } from "react";
// @material-ui/core components
import {
  Input,
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  InputAdornment,
} from "@material-ui/core";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { Link } from "react-router-dom";
import Box from "@material-ui/core/Box";
import GridContainer from "components/Grid/GridContainer.js";
import Search from "@material-ui/icons/Search";
import Button from "components/CustomButtons/Button.js";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import ArrowBackIosRoundedIcon from "@material-ui/icons/ArrowBackIosRounded";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import DateFnsUtils from "@date-io/date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import { db, auth} from "../Firebase/firebase.js";
import axios from 'axios';

import ls from "local-storage";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import moment from "moment";
import { Circles } from "react-loader-spinner";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import styles from "assets/jss/material-dashboard-react/views/EventStyle.js";


const useStyles = makeStyles(styles);

export default function Fishermen() {
  const theme = useTheme();
  const classes = useStyles();
  var mobileratio = useMediaQuery(theme.breakpoints.down("sm"));
  var desktop = useMediaQuery(theme.breakpoints.between("2490", "4000"));

  /////////Other hooks//////////
  //Seach
  const searchref = React.useRef("");

  const [searchflag, setsearchflag] = React.useState(true);
  //View
  const [viewflag, setviewflag] = React.useState(false);
  //Table Row Data
  const [rows, setRows] = React.useState([]);

  ////////Handling data change////////
  var passwordref = React.useRef("");
  const [showpassword, setShowpassword] = React.useState(false);
  //const [eventYear, setEventYear] = React.useState("");
  const [editDocID, setEditDocID] = React.useState("");
  const [fname, setFname] = React.useState("");
  const [lname, setLname] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [dob, setDOB] = React.useState(new Date());
  const [address, setAddress] = React.useState("");
  const [contactNo, setContactNo] = React.useState("");
  const [ticketNo, setTicketNo] = React.useState("");
  const [street, setStreet] = React.useState("");
  const [city, setCity] = React.useState("");
  const [town, setTown] = React.useState("");
  const [state, setState] = React.useState("");
  const [zip, setZip] = React.useState("");
  const [spinner, setSpinner] = useState(false);

  const [ageGroup, setAgeGroup] = React.useState("");
  const [registrationDays, setRegDays] = React.useState("");
  const [fee, setFee] = React.useState("");
  const [password, setPassword] = React.useState("");

  var firstnameRef = React.useRef("");
  var lastnameRef = React.useRef("");
  var emailRef = React.useRef("");
  var addressRef = React.useRef("");
  var streetRef = React.useRef("");
  var cityRef = React.useRef("");
  var townRef = React.useRef("");
  var stateRef = React.useRef("");
  var zipRef = React.useRef("");
  var phonenoRef = React.useRef("");
  var ticketRef = React.useRef(0);
  var passwordRef = React.useRef("");

  const handleEventYearChange = (e) => {
    setEventYear(e.target.value);
  };

  const handleTicketChange = (e) => {
    setTicketNo(e.target.value);
  };

  const handleFNameChange = (name) => {
    setFname(name.target.value);
  };
  const handleLNameChange = (name) => {
    setLname(name.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleDOBChange = (e) => {
    setDOB(e.target.value);
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };

  const handleCityChange = (e) => {
    setCity(e.target.value);
  };
  const handleZipChange = (e) => {
    setZip(e.target.value);
  };
  const handleStateChange = (e) => {
    setState(e.target.value);
  };
  const handleTownChange = (e) => {
    setTown(e.target.value);
  };
  const handleStreetChange = (e) => {
    setStreet(e.target.value);
  };

  const handleContactNoChange = (e) => {
    setContactNo(e.target.value);
  };

  const handleAgeGroupChange = (e) => {
    setAgeGroup(e.target.value);
  };

  const handleRegDaysChange = (e) => {
    setRegDays(e.target.value);
  };

  const showPassword = (e) => {
    if (e.target.checked === true) {
      setShowpassword(true);
    } else {
      setShowpassword(false);
    }
  };

  //Handling AddFisherman Dialog
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setFname("");
    setLname("");
    setEmail("");
    setDOB(new Date());
    setAddress("");
    setZip("");
    setState("");
    setStreet("");
    setCity("")
    setTown("")
    setContactNo("");
    setAgeGroup("");
    setRegDays("");
    setFee("");
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  //Handling View/Update Dialog
  const [openViewDialog, setViewDialog] = React.useState(false);

  const handleViewClickOpen = () => {
    setViewDialog(true);
  };
  const handleViewArrowClose = () => {
    setViewDialog(false);
  };

  const handleViewClose = () => {
    if (viewflag === true) {
      setViewDialog(false);
    } else {
      updateFisherman();
    }
  };

  //Handling Delete
  const [opendeletebox, setopendeletebox] = React.useState(false);
  const [deleteDocID, setDeleteDocID] = React.useState(false);

  const openconfirmationbox = () => {
    setopendeletebox(true);
  };
  const closeconfirmationbox = () => {
    setopendeletebox(false);
  };
  const deleteDialog = (row) => {
    setDeleteDocID(row.docId);
    setopendeletebox(true);
  };

  //Table Style
  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);


  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  
  
  
  

  



  ////////////CRUD////////////
  //Create
  const RegisterFisherman = () => {

    if (passwordRef.current.value.length > 6) {
      setSpinner(true);
     var authUser =  auth
        .createUserWithEmailAndPassword(
          emailRef.current.value,
          passwordRef.current.value
        )
        .catch((error) => {
          if (error.message === "The email address is already in use by another account.") {
            var raw = JSON.stringify({
              "data": {
                "email": emailRef.current.value
              }
            });

            var requestOptions = {
              method: 'POST',
              headers: myHeaders,
              body: raw,
              redirect: 'follow'
            };
 
            
            fetch("https://us-central1-ice-fishing-derby.cloudfunctions.net/getUser", requestOptions).then(response => response.text())
            
            .then((result) => {
              // Read result of the Cloud Function.
            
              const user = JSON.parse(result);
             
              if (user != null) {
                
                db.collection("events")
                  .where("status", "==", "Open")
                  .get()
                  .then((snapshot) => {
                    snapshot.forEach((doc) => {
                      db.collection("eventRegistration")
                        .add({
                          name:
                            firstnameRef.current.value +
                            " " +
                            lastnameRef.current.value,
                          email: emailRef.current.value,
                          dob: moment(dob).format("MM/DD/YYYY"),
                          address: addressRef.current.value,
                          zip: zipRef.current.value,
                          state: stateRef.current.value,
                          town: townRef.current.value,
                          city: cityRef.current.value,
                          street: streetRef.current.value,
                          contact: phonenoRef.current.value,
                          ageGroup: ageGroup,
                          eventId: doc.id,
                          uid: user.result.uid,
                          registrationDays: registrationDays,
                          fee: CalculateFee(registrationDays, ageGroup,ticketRef.current.value),
                          to: emailRef.current.value,
                          message: {
                            subject: "LongLake Ice-Fishing Derby Registration",
    
                            html: "Dear customer, your login password for derby application is : " + passwordRef.current.value,
                          },
                        })
                        .then((doc) => {
                          db.collection("eventRegistration").doc(doc.id).set(
                            {
                              docId: doc.id,
                            },
                            { merge: true }
                          );
    
                          if (registrationDays === "Both") {
                            db.collection("category")
                              .doc("Door")
                              .collection("tickets")
                              .doc(doc.id)
                              .set({
                                registerationId: doc.id,
                                registerationName:
                                  firstnameRef.current.value +
                                  " " +
                                  lastnameRef.current.value,
                                ticket_count: 1,
                                uid: user.result.uid,
                              })
                              .catch((err) => {
                                alert(err);
                              });
    
                            db.collection("category")
                              .doc("Medium")
                              .collection("tickets")
                              .doc(doc.id)
                              .set({
                                registerationId: doc.id,
                                registerationName:
                                  firstnameRef.current.value +
                                  " " +
                                  lastnameRef.current.value,
                                ticket_count: 1,
                                uid: user.result.uid,
                              });
    
                            db.collection("category")
                              .doc("Large")
                              .collection("tickets")
                              .doc(doc.id)
                              .set({
                                registerationId: doc.id,
                                registerationName:
                                  firstnameRef.current.value +
                                  " " +
                                  lastnameRef.current.value,
                                ticket_count: ticketRef.current.value,
                                uid: user.result.uid,
                              });
                          } else {
                            db.collection("category")
                              .doc("Door")
                              .collection("tickets")
                              .doc(doc.id)
                              .set({
                                registerationId: doc.id,
                                registerationName:
                                  firstnameRef.current.value +
                                  " " +
                                  lastnameRef.current.value,
                                ticket_count: 1,
                                uid: user.result.uid,
                              });
                          }
                          setOpen(false);
                        })
                        .catch((err) => {
                          setSpinner(false);
                          console.log(err);
                        });
                    });
                  })
                  .catch((err) => {
                    setSpinner(false);
                    alert(err);
                  });
              }

              setSpinner(false);
             
            }).catch((error) => {
              alert(error.message);
            });
          }
          else {
             alert(error.message);
          }
        })
        .then((data) => {
          if (data != null) {
            db.collection("users")
              .doc(data.user.uid)
              .set({
                type: "customer",
                uid: data.user.uid,
                date: moment(Date.now()).format("DD-MM-YYYY"),
                displayName:
                  firstnameRef.current.value + " " + lastnameRef.current.value,
                email: data.user.email,
              });
            data.user.sendEmailVerification();

            db.collection("events")
              .where("status", "==", "Open")
              .get()
              .then((snapshot) => {
                snapshot.forEach((doc) => {
                  db.collection("eventRegistration")
                    .add({
                      name:
                        firstnameRef.current.value +
                        " " +
                        lastnameRef.current.value,
                      email: emailRef.current.value,
                      dob: moment(dob).format("MM/DD/YYYY"),
                      address: addressRef.current.value,
                      zip: zipRef.current.value,
                      state: stateRef.current.value,
                      town: townRef.current.value,
                      city: cityRef.current.value,
                      street: streetRef.current.value,
                      contact: phonenoRef.current.value,
                      ageGroup: ageGroup,
                      eventId: doc.id,
                      uid: data.user.uid,
                      registrationDays: registrationDays,
                      fee: CalculateFee(registrationDays, ageGroup,ticketRef.current.value),
                      to: emailRef.current.value,
                      message: {
                        subject: "LongLake Ice-Fishing Derby Registration",

                        html: passwordRef.current.value,
                      },
                    })
                    .then((doc) => {
                      db.collection("eventRegistration").doc(doc.id).set(
                        {
                          docId: doc.id,
                        },
                        { merge: true }
                      );

                      db.collection("category")
                          .doc(ageGroup == '13 And Under' ? 'YouthCashPrizes' : 'AdultCashPrizes')
                          .collection("tickets")
                          .doc(doc.id)
                          .set({
                            registerationId: doc.id,
                            registerationName:
                              firstnameRef.current.value +
                              " " +
                              lastnameRef.current.value,
                            ticket_count: 1,
                            uid: data.user.uid,
                          })
                          .catch((err) => {
                            alert(err);
                          });

                      if (registrationDays === "Both") {
                        db.collection("category")
                          .doc("Door")
                          .collection("tickets")
                          .doc(doc.id)
                          .set({
                            registerationId: doc.id,
                            registerationName:
                              firstnameRef.current.value +
                              " " +
                              lastnameRef.current.value,
                            ticket_count: 1,
                            uid: data.user.uid,
                          })
                          .catch((err) => {
                            alert(err);
                          });

                        db.collection("category")
                          .doc("Medium")
                          .collection("tickets")
                          .doc(doc.id)
                          .set({
                            registerationId: doc.id,
                            registerationName:
                              firstnameRef.current.value +
                              " " +
                              lastnameRef.current.value,
                            ticket_count: 1,
                            uid: data.user.uid,
                          });

                        db.collection("category")
                          .doc("Large")
                          .collection("tickets")
                          .doc(doc.id)
                          .set({
                            registerationId: doc.id,
                            registerationName:
                              firstnameRef.current.value +
                              " " +
                              lastnameRef.current.value,
                            ticket_count: ticketRef.current.value,
                            uid: data.user.uid,
                          });
                      } else {
                        db.collection("category")
                          .doc("Door")
                          .collection("tickets")
                          .doc(doc.id)
                          .set({
                            registerationId: doc.id,
                            registerationName:
                              firstnameRef.current.value +
                              " " +
                              lastnameRef.current.value,
                            ticket_count: 1,
                            uid: data.user.uid,
                          });
                      }
                      setOpen(false);
                    })
                    .catch((err) => {
                      setSpinner(false);
                      console.log(err);
                    });
                });
              })
              .catch((err) => {
                setSpinner(false);
                alert(err);
              });
          }
        })
        .then(() => {
          setSpinner(false);
          searchref.current.value = "";
          getFishermen();
          setsearchflag(true);
        });
    } else {
      alert("Password length must be greater than 6 digits");
    }
  };

  //Get data (Read)
  var getFishermen = () => {
    let newArray = [];
    var openEvent = "";

    db.collection("events")
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          if (doc.data().status === "Open") {
            //console.log(doc.data().status);
            openEvent = doc.id;
            //console.log(openEvent);
          }
        });
        db.collection("eventRegistration")
          .where("eventId", "==", openEvent)
          .limit(50)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              newArray.push(doc.data());
            });
            setRows(newArray);
          })
          .catch((error) => {
            console.log("Error getting documents: ", error);
          });
      });
  };

  var getTickets = (id) => {
    db.collection("category")
      .doc("Large")
      .collection("tickets")
      .doc(id)
      .get()
      .then((doc) => {
        setTicketNo(doc.data().ticket_count);
      })
      .catch((error) => {
        setTicketNo(1)
        console.log("Error getting documents: ", error);
      });
  };

  // var getTransactions = ()=>{
  //   db.collection("transactions")
  //   .where("amount","==","$65")
  //   .get()
  //   .then((querySnapshot) => {
  //     querySnapshot.forEach((doc) => {
  //       // console.log(doc.data().uid);
  //       db.collection("eventRegistration")
  //       .where("uid","==",doc.data().uid)
  //       .where("ageGroup","==","14 And Over")
  //       .where("registrationDays","==","Both")
  //       .get()
  //       .then((qsnapshot)=>{
  //         qsnapshot.forEach((eventdata)=>{
  //           console.log(eventdata.data().name)
  //           db.collection("catgory").doc("Large")
  //           .collection("tickets").doc(eventdata.data().docId)
  //           .set({
  //             registerationName: eventdata.data().name,
  //             ticket_count: 7,
  //           },
  //           { merge: true }
  //           )
  //           .then((documnt)=>{
  //             console.log("data updated")
  //           })
  //           .catch((err)=>{
  //             console.log(err)
  //           })
  //         })
  //       })
  //       .catch((err)=>{
  //         console.log(err)
  //       })
  //     });
  //   })
  //   .catch((err)=>{
  //     console.log(err)
  //   })
  // }

  React.useEffect(() => {
    if (ls.get("currentuser") === "") {
      history.push("/login");
    } else {
      getFishermen();
    }
  }, []);

  //Update
  const updateFisherman = () => {
    setSpinner(true);
    db.collection("eventRegistration")
      .doc(editDocID)
      .set(
        {
          name: fname + " " + lname,
          email: email,
          dob: moment(dob).format("MM/DD/YYYY"),
          address: address,
          contact: contactNo,
          ageGroup: ageGroup,
          zip: zipRef.current.value,
          state: stateRef.current.value,
          town: townRef.current.value,
          city: cityRef.current.value,
          street: streetRef.current.value,
          registrationDays: registrationDays,
          // fee: CalculateFee(registrationDays, ageGroup),
        },
        { merge: true }
      )
      .then((doc) => {
        //console.log(editDocID);
        db.collection("category")
          .doc("Large")
          .collection("tickets")
          .doc(editDocID)
          .set(
            {
              registerationId: editDocID,
              registerationName: fname + " " + lname,
              ticket_count: ticketNo,
            },
            { merge: true }
          )
          .then(() => {
            setViewDialog(false);
            setTimeout(() => {
              searchref.current.value = "";
              getFishermen();
              setsearchflag(true);
            }, 1000);
            setSpinner(false);
          })
          .catch((err) => {
            console.log(err);
            setSpinner(false);
          });
      })
      .catch((err) => {
        console.log(err);
        setSpinner(false);
      });
      
  };

  //Delete
  const DeleteFisherman = () => {
    db.collection("eventRegistration")
      .doc(deleteDocID)
      .delete()
      .then(() => {
        db.collection("category").doc("Door").collection("tickets").doc(deleteDocID).delete().then(()=>{
         db.collection("category").doc("Medium").collection("tickets").doc(deleteDocID).delete().then(()=>{ 
          db.collection("category").doc("Large").collection("tickets").doc(deleteDocID).delete().then(()=>{
            console.log("Document successfully deleted!");
          })
          .catch((error) => {
            console.error("Error removing document: ", error);
          });
         })
        });

        setopendeletebox(false);
        getFishermen();
      })
      .catch((error) => {
        console.error("Error removing document: ", error);
      });
  };

  /////////////Other operations////////////////

  //Fee Calculation
  const CalculateFee = (days, ageGroup,feeToCharged) => {
    let temp = 0
    if(feeToCharged==1){
      temp = 10.0
    }
    else if(feeToCharged==3){
      temp = 20.0
    }
    else if(feeToCharged==7){
      temp = 40.0
    }
    if (days === "Saturday" || days === "Sunday") {
      if (ageGroup === "13 And Under") {
        return 10.0 + temp;
      } else {
        return 20.0 + temp;
      }
    } else {
      if (ageGroup === "13 And Under") {
        return 15.0 + temp;
      } else {
        return 30.0 + temp;
      }
    }
  };

  //Search fisherman
  const searchFisherman = () => {
    if (searchflag === true) {
      let newArray = [];
      db.collection("eventRegistration")
        .where("email", "==", searchref.current.value)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            newArray.push(doc.data());
          });
          setRows(newArray);
          setsearchflag(false);
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    } else {
      searchref.current.value = "";
      getFishermen();
      setsearchflag(true);
    }
  };

  //View Fisherman
  const viewFisherman = (row) => {
    setviewflag(true);
    setFname(row.name.split(" ", 1));
    setLname(row.name.split(" ")[1]);
    setEmail(row.email);
    setDOB(row.dob);
    setAddress(row.address);
    setStreet(row.street);
    setCity(row.city);
    setZip(row.zip);
    setTown(row.town);
    setState(row.state);
    setContactNo(row.contact);
    setAgeGroup(row.ageGroup);
    setRegDays(row.registrationDays);
    setFee(row.fee);
    getTickets(row.docId);
    setViewDialog(true);
  };

  //Update Fisherman
  const updateFishermanDialog = (row) => {
    setviewflag(false);
    setEditDocID(row.docId);
    setFname(row.name.split(" ", 1));
    setLname(row.name.split(" ")[1]);
    setEmail(row.email);
    setDOB(row.dob);
    setAddress(row.address);
    setStreet(row.street);
    setCity(row.city);
    setZip(row.zip);
    setTown(row.town);
    setState(row.state);
    setContactNo(row.contact);
    setAgeGroup(row.ageGroup);
    setRegDays(row.registrationDays);
    getTickets(row.docId);
    setViewDialog(true);
  };

  return (
    <>
      <GridContainer justify="flex-end">
        <GridItem xs={12} sm={6} md={4}>
          <div style={{ marginLeft: desktop ? "495px" : "80px" }}>
            <TextField
              placeholder="Search"
              variant="outlined"
              inputRef={searchref}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton onClick={searchFisherman}>
                      {searchflag ? <SearchIcon /> : <ClearIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </GridItem>
      </GridContainer>
      <Box pb={3} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <TableContainer
            component={Paper}
            style={{ height: 450, overflow: "scroll", display: "inline-block" }}
          >
            <Table
              stickyHeader
              style={{ width: "100%" }}
              className={classes.table}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ width: "20%" }}
                    className={(classes.tableheadercell, classes.tablehead)}
                  >
                    Fisherman ID
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    First Name
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Last Name
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Email
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    DOB
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Address
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Contact Number
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Age Group
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Registration Days
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Total Cost
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Date
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <StyledTableRow key={row.ID}>
                    <TableCell
                      onClick={() => viewFisherman(row)}
                      style={{ color: "blue" }}
                      component="th"
                      scope="row"
                    >
                      {row.docId}
                    </TableCell>

                    <TableCell align="left">
                      {row.name === null || undefined
                        ? ""
                        : row.name?.split(" ", 1)}
                    </TableCell>
                    <TableCell align="left">
                      {
                        (row.name === null || undefined
                          ? ""
                          : row.name?.split(" "))[1]
                      }
                    </TableCell>
                    <TableCell align="left">{row.email}</TableCell>
                    <TableCell align="left">{moment(row.dob).format("MM/DD/YYYY")}</TableCell>
                    <TableCell align="left">{row.address}</TableCell>
                    <TableCell align="left">{row.contact}</TableCell>
                    <TableCell align="left">{row.ageGroup}</TableCell>
                    <TableCell align="left">{row.registrationDays}</TableCell>
                    
                    <TableCell align="left">{row.fee}</TableCell>
                    <TableCell align="left">{ (typeof row.dateTime) == 'string' ? row.dateTime :   (row.dateTime == null  ? ""   : row.dateTime.toDate().toString())}</TableCell>
                 

                    <TableCell align="left">
                      <div>
                        <IconButton onClick={() => deleteDialog(row)}>
                          <DeleteForeverIcon
                            style={{ color: "red", width: "18" }}
                          />
                        </IconButton>
                        <IconButton onClick={() => updateFishermanDialog(row)}>
                          <EditIcon style={{ color: "green", width: "18" }} />
                        </IconButton>
                      </div>
                    </TableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>

      <GridContainer justify="flex-end">
        <GridItem>
          <br></br>
          <Button
            onClick={handleClickOpen}
            style={{ backgroundColor: "#171942" }}
          >
            Add User
          </Button>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="event-title"
            aria-describedby="event-description"
            fullScreen={mobileratio ? true : false}
          >
            <DialogTitle id="event-header" style={{ paddingLeft: "0" }}>
              <div>
                <IconButton onClick={handleClose}>
                  <i className="fa fa-chevron-circle-left fa-lg"></i>
                </IconButton>
                <h5 style={{ display: "inline-block" }}>Add User</h5>
              </div>
            </DialogTitle>
            <DialogContent style={{ height: 600, width: 600 }}>
              {mobileratio ? <br></br> : <br></br>}
              <div>
                <TextField
                  required
                  label="First Name"
                  variant="outlined"
                  inputRef={firstnameRef}
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  label="Last Name"
                  variant="outlined"
                  inputRef={lastnameRef}
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  label="Email"
                  inputRef={emailRef}
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />

                <br></br>
                <br></br>
                <TextField
                  id="start-date-picker"
                  variant="outlined"
                  label="Date of Birth"
                  type="date"
                  defaultValue={moment(dob).format("YYYY-MM-DD")} 
                  format="dd/MM/yyyy"
                  //value={dob}
                  onChange={handleDOBChange}
                  style={{ width: mobileratio ? 267 : 540 }}
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  inputRef={addressRef}
                  label="Address"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  inputRef={streetRef}
                  label="Street"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  inputRef={cityRef}
                  label="City"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  inputRef={townRef}
                  label="Town"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  inputRef={stateRef}
                  label="State"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  inputRef={zipRef}
                  label="Zip"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  label="Phone Number"
                  inputRef={phonenoRef}
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>

                <br></br>
                <TextField
                  type="number"
                  label="Bonus Drawing Chances"
                  inputRef={ticketRef}
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
              </div>
              <div className="event-form">
                <div>
                  <FormControl
                    style={{ width: mobileratio ? 267 : 535 }}
                    variant="outlined"
                    required
                  >
                    <InputLabel id="event_label">Age Group</InputLabel>
                    <Select
                      labelId="age_group"
                      id="age_group"
                      // value={ageGroup}
                      onChange={handleAgeGroupChange}
                      label="Age Group"
                    >
                      <MenuItem value="13 And Under">13 And Under</MenuItem>
                      <MenuItem value="14 And Over">14 And Over</MenuItem>
                    </Select>
                  </FormControl>

                  {mobileratio ? <br></br> : <br></br>}
                  {mobileratio ? <br></br> : <br></br>}

                  <FormControl
                    style={{ width: mobileratio ? 267 : 535 }}
                    variant="outlined"
                    className={classes.formControl}
                    required
                  >
                    <InputLabel id="event_label">Registration Days</InputLabel>
                    <Select
                      labelId="registration_days"
                      id="registration_days"
                      value={registrationDays}
                      onChange={handleRegDaysChange}
                      label="Registration Days"
                    >
                      <MenuItem value="Saturday">Saturday</MenuItem>
                      <MenuItem value="Sunday">Sunday</MenuItem>
                      <MenuItem value="Both">Both</MenuItem>
                    </Select>
                  </FormControl>

                  {mobileratio ? <br></br> : <br></br>}
                  {mobileratio ? <br></br> : <br></br>}
                  <TextField
                    required
                    label="Password"
                    type={showpassword ? "text" : "password"}
                    inputRef={passwordRef}
                    variant="outlined"
                    style={{ width: mobileratio ? 267 : 540 }}
                  />
                  {mobileratio ? <br></br> : null}
                  <FormControlLabel
                    control={
                      <Checkbox
                        onClick={showPassword}
                        name="checkedB"
                        color="primary"
                        style={{
                          color: "#171942",
                        }}
                      />
                    }
                    label="Show Password"
                  />
                </div>
              </div>
            </DialogContent>

            <>
              {spinner ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Circles
                    height="40"
                    width="40"
                    color="#171942"
                    ariaLabel="circles-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                  />
                </div>
              ) : (
                <DialogActions>
                  <Button
                    style={{
                      marginRight: mobileratio ? 75 : 15,
                      width: mobileratio ? 267 : 560,
                      backgroundColor: "#171942",
                    }}
                    onClick={RegisterFisherman}
                    autoFocus
                  >
                    Submit
                  </Button>
                </DialogActions>
              )}
            </>
          </Dialog>

          {/* View/Update Dialog */}
          <Dialog
            open={openViewDialog}
            onClose={handleViewArrowClose}
            aria-labelledby="event-title"
            aria-describedby="event-description"
            fullScreen={mobileratio ? true : false}
          >
            <DialogTitle id="event-header" style={{ paddingLeft: "0" }}>
              <div>
                <IconButton onClick={handleViewArrowClose}>
                  <i className="fa fa-chevron-circle-left fa-lg"></i>
                </IconButton>
              </div>
            </DialogTitle>
            <DialogContent style={{ height: 600, width: 600 }}>
              {mobileratio ? <br></br> : <br></br>}
              <div>
                <TextField
                  required
                  label="First Name"
                  value={viewflag ? fname : null}
                  defaultValue={viewflag ? null : fname}
                  variant="outlined"
                  onChange={viewflag ? null :handleFNameChange}
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  label="Last Name"
                  value={viewflag ? lname : null}
                  defaultValue={viewflag ? null : lname}
                  variant="outlined"
                  onChange={viewflag ? null :handleLNameChange}
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  label="Email"
                  value={viewflag ? email : null}
                  defaultValue={viewflag ? null : email}
                  onChange={viewflag ? null :handleEmailChange}
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />

                <br></br>
                <br></br>
                {viewflag ? (
                  <TextField
                    value={dob}
                    required
                    label="Date of Birth"
                    variant="outlined"
                    style={{ width: mobileratio ? 267 : 540 }}
                  />
                ) : (
                  <TextField
                    id="start-date-picker"
                    variant="outlined"
                    label="Date of Birth"
                    type="date"
                    defaultValue={moment(dob).format("YYYY-MM-DD")}  
                    onChange={handleDOBChange}
                    style={{ width: mobileratio ? 267 : 540 }}
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />)}

                <br></br>
                <br></br>
                <TextField
                  required
                  label="Address"
                  value={viewflag ? address : null}
                  defaultValue={viewflag ? null : address}
                  onChange={viewflag ? null : handleAddressChange}
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  inputRef={streetRef}
                  value={viewflag ? street : null}
                  defaultValue={viewflag ? null : street}
                  onChange={viewflag ? null : handleStreetChange}
                  label="Street"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  inputRef={cityRef}
                  value={viewflag ? city : null}
                  defaultValue={viewflag ? null : city}
                  onChange={viewflag ? null : handleCityChange}
                  label="City"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  inputRef={townRef}
                  value={viewflag ? town : null}
                  defaultValue={viewflag ? null : town}
                  onChange={viewflag ? null : handleTownChange}
                  label="Town"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  inputRef={stateRef}
                  value={viewflag ? state : null}
                  defaultValue={viewflag ? null : state}
                  onChange={viewflag ? null : handleStateChange}
                  label="State"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  inputRef={zipRef}
                  value={viewflag ? zip : null}
                  defaultValue={viewflag ? null : zip}
                  label="Zip"
                  variant="outlined"
                  onChange={viewflag ? null : handleZipChange}
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  required
                  label="Phone Number"
                  value={viewflag ? contactNo : null}
                  defaultValue={viewflag ? null : contactNo}
                  InputProps={{ readOnly: viewflag ? true : false }}
                  onChange={viewflag ? null :handleContactNoChange}
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  value={viewflag ? ticketNo : null}
                  type="number"
                  defaultValue={viewflag ? null : ticketNo}
                  InputProps={{ readOnly: viewflag ? true : false }}
                  label="Bonus Drawing Chances"
                  variant="outlined"
                  onChange={viewflag ? null :handleTicketChange}
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
              </div>
              <div className="event-form">
                <div>

                  <TextField
                    value={ageGroup}
                    required
                    label="Age Group"
                    variant="outlined"
                    style={{ width: mobileratio ? 267 : 535 }}
                  />

                  <br></br>
                  <br></br>

                  <TextField
                    value={registrationDays}
                    required
                    label="Registration Days"
                    variant="outlined"
                    style={{ width: mobileratio ? 267 : 535 }}
                  />

                </div>
                <br></br>
                {/* <TextField
                  required
                  label="Fee"
                  value={viewflag ? fee : ""}
                  defaultValue={viewflag ? "" : fee}
                  variant="outlined"
                  style={{
                    width: mobileratio ? 267 : 540,
                    display: "none",
                  }}
                /> */}
              </div>
            </DialogContent>
            {spinner  ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Circles
                    height="40"
                    width="40"
                    color="#171942"
                    ariaLabel="circles-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                  />
                </div>
              ) : (
            <DialogActions>
              <Button
                style={{
                  marginRight: mobileratio ? 75 : 15,
                  width: mobileratio ? 267 : 560,
                  backgroundColor: "#171942",
                }}
                onClick={handleViewClose}
              >
                {viewflag ? "Close" : "Update"}
              </Button>
            </DialogActions>
              )}
          </Dialog>

          {/* confirmation box */}
          <Dialog
            open={opendeletebox}
            onClose={closeconfirmationbox}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Are you sure you want to delete?
            </DialogTitle>
            <DialogContent></DialogContent>
            <DialogActions>
              <Button onClick={DeleteFisherman} color="primary">
                Yes
              </Button>
              <Button onClick={closeconfirmationbox} color="primary">
                No
              </Button>
            </DialogActions>
          </Dialog>
        </GridItem>
      </GridContainer>
    </>
  );
}
